import React from 'react';
import { motion } from 'framer-motion';
import FloatingBackground from '../../Common/FloatingBackground/FloatingBackground';
import './Services.css';

const Services: React.FC = () => {

  return (
    <motion.section 
      className='services cinquity-services' 
      id='services'
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <FloatingBackground />
      <div className='container'>
        <div className='section-header'>
          <h2 className='section-title'>Clinical Trial <span className="gradient-text">Support Services</span></h2>
          <p className='section-subtitle'>
            Comprehensive eCOA consulting and clinical trial support solutions
          </p>
        </div>
        <div className='services-grid'>
          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>eCOA Consulting & Implementation</h3>
            <p className='service-description'>
              Our expert eCOA consulting services offer tailored implementation, configuration, and management solutions, including ePRO, eClinRO, eObsRO, and ePerfO. We ensure precise patient-reported outcomes, enhanced compliance, and real-time data access.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>Clinical Trial Tech Consulting</h3>
            <p className='service-description'>
              Leverage our expertise in eConsent, RTSM, EDC, and system interfaces to streamline your clinical trial technology. Our services ensure seamless platform configuration and compliance with ICH-GCP, 21 CFR Part 11, and EMA guidelines.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>User Acceptance Testing (UAT)</h3>
            <p className='service-description'>
              Our UAT services provide rigorous third-party validation of clinical trial systems before launch. We offer a robust validation framework to meet audit requirements and ensure system reliability through comprehensive test plans and traceability matrices.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 7H18C18.5523 7 19 7.44772 19 8V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V8C5 7.44772 5.44772 7 6 7H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 7V5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 12H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 16H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>Licensing and Instrument Management and Control</h3>
            <p className='service-description'>
              Our comprehensive licensing management system enables seamless control over questionnaires, scales, and instruments. Benefit from multilingual support, version control, real-time reporting, and built-in regulatory compliance.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 20V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 20V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 20V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>DM & Biometrics</h3>
            <p className='service-description'>
              We offer comprehensive data management and biometrics services, including SDTM/ADaM origination, statistical reporting, and discrepancy resolution. Our analytics dashboards ensure data integrity and provide timely insights across all trial phases.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>Clinical Operations Supervision</h3>
            <p className='service-description'>
              Our operations team excels in coordinating and overseeing clinical trials, from site selection and vendor supervision to issue monitoring and change management, ensuring seamless execution throughout the study lifecycle.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>Trial Rescue Services and eCOA</h3>
            <p className='service-description'>
              Don't run into a roadblock in your study; our trial rescue experts spring into action promptly. We determine the gaps in the systems, manage reconfigurations, and assist in restoring lost timelines without sacrificing quality.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>Staff Augmentation</h3>
            <p className='service-description'>
              Include trained CRAs, data managers, and support specialists as part of your team. The clinical trial staff augmentation model provided by Cinquity guarantees fast deployment of domain-centered talent.
            </p>
          </div>

          <div className='service-card floating-card'>
            <div className='service-icon'>
              <div className='icon-bg'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3>Strategic Consulting</h3>
            <p className='service-description'>
              We support protocol development, regulatory submission planning, feasibility assessments, and vendor selection to mitigate risk and improve efficiency early in the clinical trial process.
            </p>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Services;
